// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"Game-mainContainer--1Utj4","cardsContainer":"Game-cardsContainer--2H3zY","unClickable":"Game-unClickable--3TfuD","resetButton":"Game-resetButton--Np0QA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Game/Game.scss
// module id = 57t0
// module chunks = 1